import axios from 'axios';

const API_BASE = '/api/shipments-in';

export const shipmentsInService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  getNextNo: async () => {
    const response = await axios.get(`${API_BASE}/next-no`);
    return response.data;
  },

  /** Get PO header + items to prefill a new shipment-in record. */
  getPrefillFromPo: async (poNumber) => {
    const response = await axios.get(`${API_BASE}/prefill-from-po`, {
      params: { po_number: poNumber }
    });
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  }
};
